import { Color } from "config/colors";
import { FontFamily, FontSize } from "config/font";
import styled from "styled-components";

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1301;
`;

export const ModalContainer = styled.dialog`
  background: ${Color.White};
  border-radius: 12px;
  padding: 32px;
  width: 90%;
  max-width: 400px;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1),
    0 10px 10px -5px rgba(0, 0, 0, 0.04);
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  z-index: 1301;
  border: none;
`;

export const IconContainer = styled.div<{
  variant: "warning" | "danger" | "info";
}>`
  margin-bottom: 20px;
  color: ${(props) => {
    switch (props.variant) {
      case "warning":
        return "#f59e0b";
      case "danger":
        return "#ef4444";
      case "info":
        return "#3b82f6";
      default:
        return "#f59e0b";
    }
  }};
`;

export const ContentContainer = styled.div`
  margin-bottom: 24px;
`;

export const Title = styled.h2`
  font-size: ${FontSize.Large};
  font-family: ${FontFamily.MontserratRegular}, Helvetica;
  font-weight: 600;
  color: ${Color.InputTextColor};
  margin: 0 0 8px 0;
`;

export const Message = styled.p`
  font-size: ${FontSize.Standard};
  font-family: ${FontFamily.MontserratRegular}, Helvetica;
  color: #6b7280;
  margin: 0;
  line-height: 1.5;
`;

export const ButtonContainer = styled.div`
  display: flex;
  gap: 12px;
  width: 100%;
`;

export const BaseButton = styled.button`
  flex: 1;
  padding: 12px 20px;
  border-radius: 6px;
  font-size: ${FontSize.Standard};
  font-family: ${FontFamily.MontserratRegular}, Helvetica;
  font-weight: 500;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }
`;

export const CancelButton = styled(BaseButton)`
  background-color: #f3f4f6;
  color: #374151;

  &:hover {
    background-color: #e5e7eb;
  }
`;

export const ConfirmButton = styled(BaseButton)<{
  variant: "warning" | "danger" | "info";
}>`
  background-color: ${(props) => {
    switch (props.variant) {
      case "warning":
        return "#f59e0b";
      case "danger":
        return "#ef4444";
      case "info":
        return `${Color.DarkGrey}`;
      default:
        return "#f59e0b";
    }
  }};
  color: ${Color.White};

  &:hover {
    background-color: ${(props) => {
      switch (props.variant) {
        case "warning":
          return "#d97706";
        case "danger":
          return "#dc2626";
        case "info":
          return `${Color.LightGrey03}`;
        default:
          return "#d97706";
      }
    }};
  }
`;
